export const PERMISSION_SUBJECTS = {
  academyTopic: 'AcademyTopic',
  blacklist: 'Blacklist',
  courseAssessmentMentee: 'CourseAssessmentMentee',
  coursePauseRequest: 'CoursePauseRequest',
  library: 'Library',
  menteeModule: 'MenteeModule',
  playlist: 'Playlist',
  rawAsset: 'RawAsset',
  recordingRequest: 'RecordingRequest',
  sbatGroup: 'SbatGroup',
  superBatch: 'SuperBatch',
  superBatchModule: 'SuperBatchModule',
  userCredit: 'UserCredit',
  capstoneSubmission: 'CapstoneSubmission',
} as const;
